import { isEmpty, isNil } from "lodash";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import Flx from "../../../../../components/layout/Flx";
import Htag from "../../../../../components/typography/Htag";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetParamsValue,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../../redux/actions/sidebarActions";
import LoanDrilldownButtonAddEscrowItem from "../../../buttons/LoanDrilldownButtonAddEscrowItem";
import EscrowItemsTable from "../tables/EscrowItemsTable";
import InsetCard from "../../../../../components/ui/InsetCard";
import { addressLabel } from "../../../../../_src_shared/utils/functions/addressLabel";

const LoanFeesSubTabEscrowItems = () => {
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  // const escrowItems = useSelector(
  //   (state) => state?.loanFetchedData?.escrowItems
  // );
  const escrowItems = loanTerms?.escrowItems;
  const headerSubtitle = useMemo(() => {
    if (isEmpty(escrowItems)) {
      return "Add and manage escrow items associated with this loan.";
    }
    return "Click any of the following rows to edit an escrow item";
  }, [loanDrilldown, escrowItems]);
  return (
    <PrimaryContentCard
      expandedable
      maxWidth="lg"
      title="Escrow Items By Property"
      subTitle={headerSubtitle}
      loading={isNil(loanTerms)}
    >
      <Flx column g={2}>
        {loanDrilldown?.subjectProperties?.map((p) => (
          <EscrowItemsSection propertyId={p?._id} />
        ))}
      </Flx>
    </PrimaryContentCard>
  );
};

const EscrowItemsSection = ({ propertyId }) => {
  const [rowData, setRowData] = useState();
  const loanDrilldown = useSelector((state) => state.loanDrilldown);
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const dispatch = useDispatch();
  // const escrowItems = useSelector(
  //   (state) => state?.loanFetchedData?.escrowItems
  // );
  const escrowItems = loanTerms?.escrowItems;
  const onRowClicked = useCallback((d) => {
    dispatch(sidebarTypeSet(loanDrilldownSidebarTypes.ADD_LOAN_ESCROW_ITEM));
    dispatch(sidebarSetParamsValue(null));
    dispatch(sidebarSetStateValue(d));
  }, []);

  const title = useMemo(() => {
    const property = loanDrilldown?.subjectProperties?.find(
      (p) => p._id === propertyId
    );
    const address = addressLabel(property?.address) || "Unknown Property";
    return address;
  }, [loanDrilldown?.subjectProperties, propertyId]);

  useEffect(() => {
    const filteredItems = escrowItems?.filter(
      (item) => item?.subjectPropertyId === propertyId
    );

    setRowData(filteredItems || []);
  }, [escrowItems, propertyId]);

  return (
    <Flx column gap={1} sx={{ mt: 4 }}>
      <Flx fw jb ac>
        <Flx column>
          <Htag variant="h3">{title}</Htag>
          {/* <Txt secondary>
            Click any of the following rows to edit an escrow item
          </Txt> */}
        </Flx>
        <LoanDrilldownButtonAddEscrowItem subjectPropertyId={propertyId} />
      </Flx>

      <InsetCard sx={{ p: 0, overflow: "hidden" }}>
        <EscrowItemsTable onRowClicked={onRowClicked} rowData={rowData} />
      </InsetCard>
    </Flx>
  );
};

/**
 * COMPONENTS
 */

export default LoanFeesSubTabEscrowItems;
